<template>
	<div>
		<template v-for="option in filter.inputs.value.options">
			<div class="form-group" :key="option.value">
				<label class="form-label label-auto" :for="'opt-'+option.value">
					<input type="radio" name="options[]" :id="'opt-'+option.value" v-model="value" :value="option.value" />
					{{ option.label }}
				</label>
			</div>
		</template>
	</div>
</template>

<script>
	import ListingFilterMixin from './ListingFilterMixin.js';

	export default{
		mixins	: [
			ListingFilterMixin
		],

		data () {
			return {
				value : [],
			}
		}, 
		
		computed : {
			data (){
				return {
					value : this.value
				};
			}
		}
	}
</script>